import axios from "axios";
import Format from "string-format";
import { useCallback, useState } from "react";
import { PLANNER_SCRAPER_FETCH_ENDPOINT } from "../../../_actions/endpoints";

const scrapeUrl = (url) =>
  axios
    .get(Format(PLANNER_SCRAPER_FETCH_ENDPOINT, url))
    .then((res) => res?.data);

const cache = {};
const error = {};
const inProgress = {};

export default () => {
  const [count, setCount] = useState(0);

  const getScraperData = useCallback((link) => cache?.[link], [cache]);

  const saveScraperData = useCallback(
    (link, data) => {
      cache[link] = data;
      setCount(count + 1);
    },
    [setCount, count, cache]
  );

  const deleteScraperData = useCallback(
    (link) => {
      delete cache?.[link];
      setCount(count + 1);
    },
    [setCount, count, cache]
  );

  const fetchScraperData = useCallback(
    async (link, forceUpdate) => {
      if (!forceUpdate && (getScraperData(link) || error?.[link] >= 3)) {
        return getScraperData(link);
      }

      if (!inProgress?.[link]) {
        inProgress[link] = scrapeUrl(link);
      }

      const response = await inProgress[link];

      if (response?.status === 1) {
        saveScraperData(link, response.data);
      } else {
        error[link] = (error?.[link] || 0) + 1;
      }

      if (inProgress?.[link]) {
        delete inProgress[link];
      }

      return getScraperData(link);
    },
    [scrapeUrl, saveScraperData, getScraperData, inProgress, error]
  );

  return {
    deleteScraperData,
    fetchScraperData,
  };
};
